import React, { useState } from "react";
import styled from "styled-components";
import Container from "../Common/Container";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

const Section = styled.section`
  background: #fff;
  border-radius: 1.2rem;
  padding: 2.5rem 1rem;
  margin: 3rem 0;
  text-align: center;
  border: 2px solid #e97d7dff;
`;

const Input = styled.input`
  padding: 0.8rem 1.2rem;
  border-radius: 2rem 0 0 2rem;
  border: 1px solid #e97d7dff;
  font-size: 1rem;
  outline: none;
  width: 220px;
  max-width: 80vw;
`;

const Button = styled.button`
  padding: 0.8rem 1.5rem;
  border-radius: 0 2rem 2rem 0;
  border: none;
  background: #e97d7dff;
  color: #fff;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s;
  &:hover {
    background: #e97d7dff;
  }
`;

const NewsletterSignup: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email.trim()) {
      // Store email in localStorage for pre-filling
      localStorage.setItem("prefillEmail", email.trim());
      // Navigate to signup page
      navigate("/signup");
    }
  };

  return (
    <section>
      {user ? (
        <></>
      ) : (
        <Container>
          <Section>
            <h2 style={{ fontSize: "1.5rem", marginBottom: "1rem" }}>
              Get 10% Off Your First Order
            </h2>
            <form
              style={{ display: "inline-flex", alignItems: "center" }}
              onSubmit={handleSubmit}
            >
              <Input
                type="email"
                placeholder="Your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <Button type="submit">Sign Up</Button>
            </form>
            <div
              style={{
                marginTop: "0.7rem",
                color: "#e97d7dff",
                fontSize: "0.97rem",
              }}
            >
              Join our newsletter for exclusive updates & new releases.
            </div>
          </Section>
        </Container>
      )}
    </section>
  );
};

export default NewsletterSignup;
